// services/categorieService.js
import api from './auth';

export const categorieService = {
  // Récupérer toutes les catégories
  getAllCategories: async (params = {}) => {
    try {
      const response = await api.get('/inventory/categories/', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des catégories:', error);
      throw error;
    }
  },

  // Récupérer une catégorie par ID
  getCategorieById: async (id) => {
    try {
      const response = await api.get(`/inventory/categories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération de la catégorie ${id}:`, error);
      throw error;
    }
  },

  // Créer une nouvelle catégorie
  createCategorie: async (categorieData) => {
    try {
      // Pour les images, utilisez FormData
      const formData = new FormData();
      formData.append('nom', categorieData.nom);
      formData.append('description', categorieData.description);
      
      if (categorieData.image && categorieData.image instanceof File) {
        formData.append('image', categorieData.image);
      }

      const response = await api.post('/inventory/categories/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la catégorie:', error);
      throw error;
    }
  },

  // Mettre à jour une catégorie
  updateCategorie: async (id, categorieData) => {
    try {
      const formData = new FormData();
      formData.append('nom', categorieData.nom);
      formData.append('description', categorieData.description);
      
      if (categorieData.image) {
        if (categorieData.image instanceof File) {
          formData.append('image', categorieData.image);
        } else if (categorieData.image === null) {
          // Pour supprimer l'image
          formData.append('image', '');
        }
      }

      const response = await api.patch(`/inventory/categories/${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la catégorie ${id}:`, error);
      throw error;
    }
  },

  // Supprimer une catégorie
  deleteCategorie: async (id) => {
    try {
      const response = await api.delete(`/inventory/categories/${id}/`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression de la catégorie ${id}:`, error);
      throw error;
    }
  },

  // Rechercher des catégories
  searchCategories: async (searchTerm) => {
    try {
      const response = await api.get('/inventory/categories/', {
        params: { search: searchTerm }
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche des catégories:', error);
      throw error;
    }
  },
};

export default categorieService;